import { paths } from '@issuemanager/apps/client/paths';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// this string won't be translated
const highbond = 'HighBond';

export function useDynamicDocumentTitle() {
  const location = useLocation();
  const { t } = useTranslation(['common', 'issue', 'settings']);

  const getPrefix = useCallback(() => {
    const keys = location.pathname.split('/');

    if (keys.includes(paths.issues.index)) {
      // issue code
      if (keys[2]) {
        if (keys.includes(paths.issues.manage)) {
          return t('issue:tabs.manageIssue');
        }
        return t('issue:tabs.viewIssue');
      }

      return t('issue:tabs.masterIssues');
    }

    if (keys.includes(paths.issues.create)) {
      return t('issue:form.new.title');
    }

    if (keys.includes(paths.settings.index)) {
      if (keys.includes(paths.issueTypes.index)) {
        return t('settings:issueTypes.tabName');
      }

      if (keys.includes(paths.issueTemplates.index)) {
        if (keys.includes(paths.issueTemplates.add)) {
          return t('settings:issueTemplates.add');
        }

        return t('settings:issueTemplates.tabName');
      }

      if (keys.includes(paths.slaConfiguration.index)) {
        return t('settings:slaConfiguration.tabName');
      }
    }

    return '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const prefix = getPrefix();

  const title = prefix
    ? `${prefix} - ${t('appName')} - ${highbond}`
    : `${t('appName')} - ${highbond}`;

  document.title = title;
}
